module.exports = __webpack_public_path__ + "static/media/SelectTiff.c30c7ba8.png";